import { db } from '../services/firebase'

export const getHydratedUser = async userId => {
  // First, fetch all fields
  const baseUser = getUserFields()

  // Get fields from authResponse
  const hydratedUser = Object.assign(baseUser, { userId })
  const userDocumentReference = db.doc(`users/${userId}`)
  let userDocument
  try {
    userDocument = await userDocumentReference.get()
  } catch (error) {
    console.error(error)
  }

  if (userDocument && userDocument.exists) {
    // Hydrate from firestore
    const userInformations = userDocument.data()

    Object.keys(userInformations).forEach(key => {
      hydratedUser[key] = userInformations[key]
    })
  }

  return hydratedUser
}

export const getUserFields = () => {
  return {
    email: '',
    emailVerified: '',
    firstname: '',
    lastname: '',
    userId: '',
    birthday: '',
    phoneNumber: ''
  }
}
